import { useFormContext } from 'react-hook-form';
import {
  ContributionFormData,
  SetPerformerRoleDetailHistory,
} from 'app/components/Song/Contributions/ContributionForm/types';
import { Option } from 'types/general.types';
import { formatGroupedOptions } from 'app/components/Song/Contributions/ContributionForm/RoleFields/utils';
import { GridItem } from '@chakra-ui/react';
import { ChakraAutocompleteField, InputField } from 'app/components/Core';
import React from 'react';
import { DetailField } from 'app/components/Song/Contributions/ContributionForm/RoleFields/types';

interface PerformerDetailsFieldProps {
  setPerformerRoleDetailHistory: SetPerformerRoleDetailHistory;
  performerRoleType: Option | null;
  detailField?: DetailField;
}

export const PerformerDetailsField = ({
  setPerformerRoleDetailHistory,
  performerRoleType,
  detailField,
}: PerformerDetailsFieldProps) => {
  const {
    formState: { errors },
    register,
    control,
  } = useFormContext<ContributionFormData>();

  if (!detailField) return null;
  if (detailField?.options) {
    const hasGroups = Boolean(detailField.options[0]?.group);
    const data = hasGroups
      ? formatGroupedOptions(detailField)
      : detailField?.options;

    return (
      <GridItem>
        <ChakraAutocompleteField
          control={control}
          label={detailField.label}
          name="performerRoleDetail"
          isClearable
          options={data}
          dataTestId="performer-detail"
          onChange={(value) => {
            if (value && performerRoleType) {
              setPerformerRoleDetailHistory((state) => ({
                ...state,
                [performerRoleType.value]: value.value as string,
              }));
            }
          }}
        />
      </GridItem>
    );
  }
  return (
    <GridItem>
      <InputField
        label={detailField?.label}
        isDisabled
        isInvalid={Boolean(errors?.performerRoleDetail)}
        errorMessage={errors?.performerRoleDetail?.message}
        errorMessageProps={{ 'data-testid': 'performerRoleDetail-error-text' }}
        data-testid={detailField?.label}
        overflow="hidden"
        textOverflow="ellipsis"
        width="full"
        {...register('performerRoleDetail')}
      />
    </GridItem>
  );
};
